import { COLOR_FAMILIES, COLOR_FAMILY_LABELS, type ColorFamily } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { COLOR_FAMILY_SWATCH_STYLES } from '@/shared/config';
import { cn } from '@/shared/ui';

interface ColorFamilyFilterProps {
  readonly selected: readonly ColorFamily[];
  readonly onChange: (selected: readonly ColorFamily[]) => void;
}

/** 표준 색상군 13종 전부를 노출하는 다중 선택 필터(확정 결정). */
export const ColorFamilyFilter = ({ selected, onChange }: ColorFamilyFilterProps): ReactElement => {
  const toggle = (family: ColorFamily): void => {
    onChange(
      selected.includes(family)
        ? selected.filter((value) => value !== family)
        : [...selected, family],
    );
  };

  return (
    <div>
      <ul className="grid grid-cols-3 gap-x-2 gap-y-3">
        {COLOR_FAMILIES.map((family) => {
          const isSelected = selected.includes(family);

          return (
            <li key={family} className="flex flex-col items-center gap-1">
              <button
                type="button"
                aria-pressed={isSelected}
                aria-label={COLOR_FAMILY_LABELS[family]}
                onClick={() => toggle(family)}
                style={COLOR_FAMILY_SWATCH_STYLES[family]}
                className={cn(
                  // 상세의 색상 견본과 같은 32px 지름.
                  'size-8 cursor-pointer rounded-full border border-foreground/20 transition-shadow',
                  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
                  // 흰 견본만 흰 바탕에서 묻힌다 — 경계를 더 진한 선으로 세운다.
                  family === 'WHITE' && 'border-input',
                  isSelected && 'ring-2 ring-foreground ring-offset-2',
                )}
              />
              <span className="text-xs text-muted-foreground">{COLOR_FAMILY_LABELS[family]}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
